import JQueryView, { on } from '@/common/views/jqueryView';

export default class MediaView extends JQueryView {
  constructor() {
    super('.order-body');
  }

  @on({ event: 'click', selector: 'a.disabled' })
  onClickDisabledLink() {
    return false;
  }
}
